import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withAITracking } from '@microsoft/applicationinsights-react-js'
import { selectDrawerStatus } from '../../../redux/selectors'
import { fetchDmdcStatsReports } from '../../../redux/actions'
import { formatDate, formatDateTime, formatTime } from '../../../formatting'
import Header from '../../Header'
import DmdcGraph from './DmdcGraph'
import { reactPlugin } from '../../../applicationInsights'

export function DmdcStatsReport() {
  const dispatch = useDispatch()

  const drawerIsOpen = useSelector(selectDrawerStatus)

  const getDmdcStatsReports = () => dispatch(fetchDmdcStatsReports())

  const formatTimestampLabels = (lines, reportId) => {
    switch (reportId) {
      case 'dmdc30':
        return lines.map((l) => formatDate(l.timestamp))
      case 'dmdcDay':
        return lines.map((l) => formatDateTime(l.timestamp))
      case 'dmdcHour':
        return lines.map((l) => formatTime(l.timestamp))
      default:
        return 'todo: format new line type'
    }
  }

  useEffect(() => {
    getDmdcStatsReports()
  }, [])

  return (
    <div>
      <Header title="DMDC Status" />
      <DmdcGraph formatTimestampLabels={formatTimestampLabels} reportId="dmdcHour" title="Last hour" drawerIsOpen={drawerIsOpen} />
      <DmdcGraph formatTimestampLabels={formatTimestampLabels} reportId="dmdcDay" title="Today" drawerIsOpen={drawerIsOpen} />
      <DmdcGraph formatTimestampLabels={formatTimestampLabels} reportId="dmdc30" title="Last 30 days" drawerIsOpen={drawerIsOpen} />
    </div>
  )
}

export default withAITracking(reactPlugin, DmdcStatsReport)
